/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import React, {
 ChangeEvent,
 useEffect,
 useState,
} from 'react'
import {PageTitle} from 'layout/master-layout'
// import {toast} from 'react-toastify'
import {ITab, KTTab} from 'helpers/ui-components/KTTab'
import Spinner from 'layout/common/Spinner'
import {useAuth} from 'context/AuthProvider'
import {
 IProduct,
 IProductSummary,
} from 'models/ProductManagement'
import {
 fetchSkuSummaryCount,
 fetchProductList,
} from 'utils/api/productManagementService'
import {useTranslation} from 'react-i18next'
import {IFormField} from 'models/Common'
import {KTSummaryCard} from 'helpers/ui-components/KTSummaryCard'
import {
 formatDateForDB,
 generateRandomNo,
} from 'utils/helper'
import {KTFilterBox} from 'helpers/ui-components/KTFilterBox'
import {fetchFilterConfig} from 'utils/api/auth/commonService'
import {Button, KTSVG} from 'helpers'
import {KTImage} from 'helpers/ui-components/KTImage'
import KTPagination from 'helpers/ui-components/KTPagination'
import {useNavigate} from 'react-router-dom'
import {KTSearchBox} from 'helpers/ui-components/KTSearchBox'
import {createFilterPayload} from 'utils/helpers/genericFilterForm'
import {
 getAddProductPath,
 getProductDetailsPath,
 getProductListPath,
} from './productCatalogueRoutes'

const ProductCataloguePage = () => {
 const {t} = useTranslation()
 const navigate = useNavigate()
 const {userData} = useAuth()
 const accessDetails =
  userData?.userSubModule?.productCatalogue?.homePage
 const [loader, setLoader] = useState(false)
 const [searchTerm, setSearchTerm] = useState('')
 const [actionDetails, setActionDetails] =
  useState<IFormField | null>(null)
 const [itemsPerPage, setItemsPerPage] = useState(25)
 const [filterCount, setFilterCount] = useState(0)
 const [currentPage, setCurrentPage] = useState(1)
 const [totalRecords, setTotalRecords] = useState(0)
 const [skuCount, setSkuCount] =
  useState<IProductSummary | null>(null)
 const [filterFormData, setFilterFormData] =
  useState<IFormField | null>(null)
 const [filterConfig, setFilterConfig] = useState<
  IFormField[]
 >([])
 const [productList, setProductList] = useState<IProduct[]>(
  []
 )

 const getFilterConfig = async () => {
  setLoader(true)
  const res = await fetchFilterConfig({
   filter_type: 'PRODUCT',
   organisation_type: 'PMU',
  })
  if (res) {
   setFilterConfig(res?.applicableFilters ?? [])
  }
  setLoader(false)
 }

 const getSkuCount = async () => {
  setLoader(true)
  const res = await fetchSkuSummaryCount({})
  if (res) {
   setSkuCount(res)
  }
  setLoader(false)
 }

 const getProductList = async (pageNo: number) => {
  setLoader(true)
  const payload = await createFilterPayload(
   filterConfig,
   filterFormData
  )
  setFilterCount(payload.totalAppliedFilters)
  delete payload.totalAppliedFilters
  const res = await fetchProductList({
   //    distributor_id: userData?.userId,
   page: pageNo,
   page_size: itemsPerPage,
   ...payload,
   ...(searchTerm && {
    search: searchTerm,
   }),
  })
  if (res) {
   setProductList(res.results ?? [])
   setTotalRecords(res?.count ?? 0)
  }
  setLoader(false)
 }

 const handleActionBtnClick = (data: IFormField | null) => {
  setActionDetails({
   productId: data?.productId,
   status: data?.status,
  })
 }

 const handlePageChange = async (pageNo: number) => {
  setCurrentPage(pageNo)
  await getProductList(pageNo)
 }

 const reloadTableData = async () => {
  await getProductList(currentPage)
 }

 useEffect(() => {
  void getSkuCount()
  void getFilterConfig()
 }, [])

 useEffect(() => {
  if (currentPage !== 1) {
   setCurrentPage(1)
  }
  void getProductList(1)
 }, [filterFormData, searchTerm, itemsPerPage])

 return (
  <>
   {loader && <Spinner />}
   <div className='w-full min-h-full'>
    <KTFilterBox
     parentId={'Product_list'}
     btnText={''}
     containerClass='bg-white border-none mt-4 pl-0'
     dateRangeContainerClass='mx-6'
     dateRangeTitle={t('common.dateRange')}
     showDateRangeBox={false}
     filterConfig={filterConfig}
     filterCount={filterCount}
     setLoader={setLoader}
     filterFormData={filterFormData}
     setFilterFormData={setFilterFormData}
    >
     <span className='text-base text-[#2F2F2F] font-semibold pl-2'>
      {t('productMgmt.applyFilters')}
     </span>
    </KTFilterBox>

    <div className='mt-4 mb-5 pb-4 border-[#E6EBF0] border-b'>
     <p className='text-[#2F2F2F] text-lg font-medium'>
      {t('productMgmt.overAllSummary')}
     </p>
     <div className='flex items-center gap-6 mt-4'>
      <KTSummaryCard
       title={t('productMgmt.noOfSKUs')}
       count={skuCount?.total_variant_skus}
       containerClass='flex flex-col items-center w-[165px] justify-center !px-2 bg-[#F2F2F2] border-[#B3B3B3] !py-2'
       color={''}
      />
      <KTSummaryCard
       title={t('productMgmt.activeSKUs')}
       count={skuCount?.active_skus}
       containerClass='flex flex-col items-center w-[165px] justify-center !px-2 bg-[#F2F2F2] border-[#B3B3B3] !py-2'
       color={''}
      />
     </div>
    </div>

    <div className='my-6'>
     <p className='text-[#2F2F2F] text-xl font-medium'>
      {t('productMgmt.allProducts')}
     </p>
     <div className='grid md:grid-cols-2 items-center gap-4 my-4'>
      <KTSearchBox
       label={t('productMgmt.search')}
       placeholder={t('productMgmt.searchText')}
       setSearchTerm={setSearchTerm}
      />
      <div className='flex gap-4 items-center justify-end'>
       {/* <Button
        type='button'
        disabled={false}
        onClick={() => {}}
        color='blue'
        className='text-center py-2.5 px-4 bg-[#4E83E4] 
        !rounded-lg text-base text-white hover:bg-white hover:!text-[#4E83E4] font-semibold border-[#4E83E4]'
       >
        {t('productMgmt.bulkUpload')}
       </Button> */}
       {accessDetails?.section?.productDetails?.canAdd && (
        <Button
         type='button'
         disabled={false}
         onClick={() => {
          navigate(getAddProductPath())
         }}
         color='blue'
         className='text-center py-2.5 px-4 bg-[#4E83E4] 
        !rounded-lg text-base text-white hover:bg-white hover:!text-[#4E83E4] font-semibold border-[#4E83E4]'
        >
         {t('productMgmt.addNewProduct')}
        </Button>
       )}
       {accessDetails?.section?.manageCatalogue
        ?.canView && (
        <Button
         type='button'
         disabled={false}
         onClick={() => {
          navigate(getProductListPath())
         }}
         color='blue'
         className='text-center py-2.5 px-4 bg-[#4E83E4] 
        !rounded-lg text-base text-white hover:bg-white hover:!text-[#4E83E4] font-semibold border-[#4E83E4]'
        >
         {t('productMgmt.manageCatalogue')}
        </Button>
       )}
      </div>
     </div>

     <div className='grid md:grid-cols-6 items-center gap-4 mt-6 mb-10'>
      {productList.map((val: IProduct, key: number) => (
       <div
        key={val.id}
        className={`${
         accessDetails?.section?.productDetails?.canView &&
         'cursor-pointer'
        } bg-white w-full h-full border-[#E6EBF0] border pb-2 shadow-inner rounded-xl inline-block`}
        onClick={() => {
         if (
          accessDetails?.section?.productDetails?.canView
         ) {
          navigate(getProductDetailsPath(val.id))
         }
        }}
       >
        <div
         key={val?.business_group?.id}
         className='w-full h-[140px] flex items-center justify-center bg-[#F5F8FA] rounded-tl-xl rounded-tr-xl'
        >
         <KTImage
          width={350}
          height={140}
          className={'max-w-[83px] max-h-[120px]'}
          src={val.images}
          defalutImgSrc='/media/img/product-default-img.png'
          alt={'name'}
         />
        </div>
        <div className='px-[5px]'>
         <div
          className='pt-6 px-3 text-base font-medium text-[#2F2F2F] relative'
          title={val.name}
         >
          {`${val.name.substring(0, 27)}`}
          {val.name.length > 27 && '..'}
          <div className='text-sm font-medium text-[#999999] pb-2'>
           {val.brand?.name}
          </div>
         </div>
        </div>
       </div>
      ))}
     </div>
     <KTPagination
      currentPage={currentPage}
      itemsPerPage={itemsPerPage}
      totalRecord={totalRecords}
      onPageChange={handlePageChange}
      setItemsPerPage={setItemsPerPage}
     />
    </div>
   </div>
  </>
 )
}

export default function ProductCataloguePageWrapper() {
 const {t} = useTranslation()
 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white'>
    <PageTitle
     breadcrumbContainerClass={
      'flex text-[#5A6066] text-sm font-normal items-center pb-6 border-[#E6EBF0] border-b'
     }
     breadcrumbs={[
      {
       title: t('breadCrumbs.home'),
       path: '/home-page',
       isActive: false,
      },
      {
       title: t('breadCrumbs.productCatalogue'),
       path: '',
       isActive: true,
      },
     ]}
     description='Welcome'
    >
     {t('breadCrumbs.productCatalogue')}
    </PageTitle>
    <ProductCataloguePage />
   </div>
  </div>
 )
}
